/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Injection_CompleteInputs */

const en_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewording suggestions ready — review them below`)
};

const de_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umformulierungsvorschläge bereit — sieh sie dir unten an`)
};

const fr_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions de reformulation prêtes — consultez-les ci-dessous`)
};

const es_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencias de reformulación listas — revísalas abajo`)
};

const it_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerimenti di riformulazione pronti — controllali qui sotto`)
};

const nl_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herformuleringssuggesties klaar — bekijk ze hieronder`)
};

const pl_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestie przeformułowania gotowe — sprawdź je poniżej`)
};

const fi_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uudelleenmuotoiluehdotukset valmiina — tarkista ne alta`)
};

const da_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omformuleringsforslag klar — gennemgå dem nedenfor`)
};

const sv_keyword_optimizer_toast_injection_complete = /** @type {(inputs: Keyword_Optimizer_Toast_Injection_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omformuleringsförslag klara — granska dem nedan`)
};

/**
* | output |
* | --- |
* | "Rewording suggestions ready — review them below" |
*
* @param {Keyword_Optimizer_Toast_Injection_CompleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_injection_complete = /** @type {((inputs?: Keyword_Optimizer_Toast_Injection_CompleteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Injection_CompleteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_injection_complete(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_injection_complete(inputs)
	return en_keyword_optimizer_toast_injection_complete(inputs)
});